import { useCallback } from 'react';
import { RecorderConfig } from 'modules/video-markers/domain/interfaces';
import { parseRecorderFragment, recorderConfigToFragment } from 'modules/video-markers/domain/utils';
import { useLocalStorage } from 'shared/hooks/use-local-storage';

/**
 * Подключение к программе выставляют один раз под свою машину, поэтому оно переживает
 * перезагрузку страницы, как и «скрыть панель» (`devices/ui/hooks/use-hide-panel-option.ts`).
 * Хранится строкой фрагмента — тем же форматом, что уезжает в ссылку, и разбирается тем же
 * `parseRecorderFragment`, что и в оверлее: испорченное значение даёт «выключено», а не падение.
 */
const RECORDER_LINK_CONFIG = {
  recorder: {
    key: 'devicesOverlayRecorder',
    defaultValue: null as RecorderConfig | null,
    parser: (value: string) => parseRecorderFragment(value),
    // `null` до сериализатора не доходит — `useLocalStorage` удаляет ключ; тип шире ради вывода `U`.
    serializer: (value: RecorderConfig | null) => (value ? recorderConfigToFragment(value) : ''),
  },
};

/** Куда оверлей подключится за позицией записи; `null` — видеометки выключены, фрагмента в ссылке нет. */
export function useRecorderLinkOption() {
  const [values, setValues] = useLocalStorage(RECORDER_LINK_CONFIG);

  const setRecorder = useCallback((value: RecorderConfig | null) => setValues({ recorder: value }), [setValues]);

  return { recorder: values.recorder, setRecorder };
}
